__webpack_require__.p = "/discover/_next/";